import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { muiAbtn, muiBbtn } from "./style";

import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  doc,
  query,
  orderBy,
  deleteDoc,
} from "firebase/firestore";
import LinearProgress from "@mui/material/LinearProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExcelUploader from "./ExcelUploader";

export default function AllServices() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const [isProcessing, setisProcessing] = useState(false);
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [DocId, setDocId] = useState(-1);
  const [openDialog, setOpenDialog] = React.useState(false);

  useEffect(() => {
    let active = true;
    const getData = async () => {
      setLoading(true);
      /////Getting the latest document first.
      const data = await getDocs(
        query(collection(db, "services"), orderBy("created_on", "desc"))
      );
      //////Mapping Through App Documents And Then Saving them in rows useState.
      data.docs.map((document) => {
        setRows((row) => [
          ...row,
          {
            ...document.data(),
            id: document.id,
          },
        ]);
      });

      if (!active) {
        return;
      }

      setLoading(false);
      return () => {
        active = false;
      };
    };
    getData();
  }, []);

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setDocId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocId("");
    setisProcessing(false);
  };

  const deleteService = () => {
    setisProcessing(true);
    deleteDoc(doc(db, "services", DocId))
      .then(() => {
        console.log(isProcessing);
        toast.success("Service Deleted");
        setRows(rows.filter((row) => row.id !== DocId));
        handleCloseDialog();
      })
      .catch((error) => {
        toast.error("Error! Unable to Delete Service");
        console.log(error);
        handleCloseDialog();
      });
  };

  const columns = [
    // { field: "id", headerName: "ID", width: "60" },
    {
      field: "Profile",
      headerName: "",
      width: "500",
      align: "left",
      renderCell: profileCell,
    },

    {
      field: "Action",
      width: "400",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function profileCell(params) {
    return (
      <>
        <div class="row">
          <div class="col-4">
            <img
              className="rounded-4"
              src={params.row.thumbnail}
              width="50px"
              height="50px"
            />
          </div>
          <div class="col-8 d-flex justify-content-left flex-wrap align-items-center">
            <span class="ms-1">
              <b>{params.row.title}</b>
              <br />
              <small class="text-muted">
                {new Date(
                  params.row.created_on.seconds * 1000
                ).toLocaleTimeString()}
                <FiberManualRecordIcon sx={{ fontSize: "5px" }} />
                <b
                  role="button"
                  onClick={() => navigate(`/ViewService/${params.row.id}`)}
                >
                  {" "}
                  Details
                </b>
              </small>
            </span>
          </div>
        </div>
      </>
    );
  }

  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => navigate(`/AddNewService/${params.row.id}`)}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
        // startIcon={<CancelIcon />}
        >
          Delete
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,

        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Delete the Service?"}
        </DialogTitle>

        <DialogActions>
          {isProcessing ? (
            <LinearProgress />
          ) : (
            <>
              <Button onClick={() => deleteService()}>Yes</Button>
              <Button onClick={handleCloseDialog} autoFocus>
                No
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>ALL Services</b>
            </h1>

            <Button
              variant="contained"
              color="primary"
              style={muiBbtn}
              disable={isProcessing}
              size="small"
              // startIcon={<CheckCircleIcon />}
              onClick={() => navigate("/AddNewService")}
            >
              Add New Service
            </Button>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>


        <ExcelUploader />




        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Services</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={6}
            rowsPerPageOptions={[5]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            disableSelectionOnClick
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
          />
        </div>
      </Card>
    </div>
  );
}
